import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'

function SnapModal(props) {

    const {
        show,
        id,
        handleClose,
        printSnap,
        //saveSnapData,
        deleteSnap,
        snapShots
    } = props

    const [comment, setComment] = useState('')
    // const [snap, setSnap] = useState(null)

    useEffect(() => {
        if (!id) return
        // const selectedCanvas = document.getElementById(id)
        // selectedCanvas.setAttribute('id', `${id}b`)
        // setSnap(selectedCanvas)
        //const canvasEditBox = document.getElementById('canvas-edit-box')
        //canvasEditBox.appendChild(selectedCanvas)
        const found = snapShots.find(x => x.id === id)
        if (found) {
            setComment(found.comment)
        }
    }, [id, snapShots])


    return (
        <Modal show={show} onHide={handleClose} animation={true} size={'lg'}>
            <Modal.Header closeButton>
                <Modal.Title>{'Επεξεργασία εικόνας'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center" id="canvas-edit-box">

                </div>
                <div className="mt-4">
                    <h4>{'Γράψτε τα σχόλιά σας:'}</h4>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        autoFocus
                        style={{ height: 100 + 'px', width: 80 + '%', display: 'block', margin: '0 auto' }} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    style={{ left: '20px', position: 'absolute' }}
                    variant="danger"
                    onClick={() => deleteSnap(id)}>
                    {'Διαγραφή'}
                </Button>
                {/* <Button variant="secondary" onClick={handleClose}>
                    {'Κλείσιμο'}
                </Button>
                <Button variant="primary" onClick={() => saveSnapData(id, comment)}>
                    {'Αποθήκευση'}
                </Button> */}
                <Button variant="primary" onClick={() => printSnap(id, comment)}>
                    {'Εκτύπωση'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default SnapModal